// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__QSpNi","title":"Images90_title__3fYaN","images":"Images90_images__fae4_"};